/* ============ LOUBELLE THEME JS ============ */

/* ---- Header scroll ---- */
const hdr=document.querySelector('.site-header');
if(hdr) addEventListener('scroll',()=>hdr.classList.toggle('scrolled',scrollY>60));

/* ---- Smooth nav + mobile menu ---- */
function go(id){toggleMenu(false);const el=document.getElementById(id);if(el)el.scrollIntoView({behavior:'smooth'});}
function toggleMenu(open){const m=document.getElementById('mobileMenu');if(m)m.classList.toggle('open',open);}

/* ---- Reveal on scroll ---- */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('in')}),{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
}else{
  document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));
}

/* ---- CAROUSEL ENGINE ---- */
function initCarousel(car){
  const track=car.querySelector('.track');
  if(!track)return;
  const slides=track.children.length;
  const dotsWrap=car.querySelector('.dots');
  car.dataset.idx='0';
  if(dotsWrap){
    dotsWrap.innerHTML='';
    for(let i=0;i<slides;i++){
      const b=document.createElement('button');
      if(i===0)b.classList.add('on');
      b.onclick=()=>cGo(car,i);
      dotsWrap.appendChild(b);
    }
  }
  if(slides<=1){car.querySelectorAll('.nav,.dots').forEach(e=>e.style.display='none');}
  cGo(car,0);
}
function cGo(car,i){
  const track=car.querySelector('.track');
  const n=track.children.length;
  i=(i+n)%n;
  car.dataset.idx=i;
  track.style.transform=`translateX(${-i*100}%)`;
  car.querySelectorAll('.dots button').forEach((d,x)=>d.classList.toggle('on',x===i));
  Array.from(track.children).forEach((slide,x)=>{
    slide.querySelectorAll('video').forEach(v=>{x===i?v.play().catch(()=>{}):v.pause();});
  });
}
function cStep(btn,dir){const car=btn.closest('.carousel');cGo(car,parseInt(car.dataset.idx)+dir);}
function autoRotate(car){
  setInterval(()=>{
    if(document.hidden)return;
    const t=car.querySelector('.track');
    if(t&&t.children.length>1) cGo(car,parseInt(car.dataset.idx)+1);
  },5500);
}
document.querySelectorAll('[data-carousel]').forEach(c=>{initCarousel(c);autoRotate(c);});

/* ---- PIECES CAROUSEL ---- */
function piecesStep(btn,dir){
  const stage=btn.closest('.pieces-stage');
  const carousel=stage&&stage.querySelector('[data-pieces-carousel]');
  const card=carousel&&carousel.querySelector('.card');
  if(!carousel||!card)return;
  const gap=parseFloat(getComputedStyle(carousel.querySelector('.pieces-track')).gap)||0;
  carousel.scrollBy({left:dir*(card.getBoundingClientRect().width+gap),behavior:'smooth'});
}

/* ---- PRODUCT VARIANTS (product template) ---- */
let selectedVariantId = window.LOUBELLE_DEFAULT_VARIANT || null;
function selectVariant(btn,variantId,available){
  document.querySelectorAll('.variant').forEach(x=>x.classList.remove('sel'));
  btn.classList.add('sel');
  selectedVariantId=variantId;
  const add=document.getElementById('addBtn');
  if(add){
    add.disabled=!available;
    const inquiryLabel=add.dataset.inquiryLabel || 'Add an inquiry';
    add.textContent=available?(window.LOUBELLE_QUOTE_MODE==='cart'?'Add to cart':inquiryLabel):'Sold out';
  }
}
function addCurrentToCart(){
  if(!selectedVariantId){alert('Please select a size');return;}
  addToCart(selectedVariantId,1);
}

/* ---- SHOPIFY AJAX CART ---- */
async function addToCart(variantId,qty){
  try{
    const res=await fetch('/cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:variantId,quantity:qty||1}]})
    });
    if(!res.ok){const e=await res.json();alert(e.description||'Could not add to cart');return;}
    await refreshCart();
    openCart();
  }catch(err){alert('Network error. Please try again.');}
}
async function changeQty(key,qty){
  await fetch('/cart/change.js',{
    method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})
  });
  await refreshCart();
}
function money(cents){
  return '€'+(cents/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2});
}
async function refreshCart(){
  const countEl=document.getElementById('navCount');
  const wrap=document.getElementById('cartItems');
  if(!countEl&&!wrap)return;
  const res=await fetch('/cart.js');
  const cart=await res.json();
  if(countEl)countEl.textContent=cart.item_count;
  if(!wrap)return;
  if(cart.item_count===0){
    wrap.innerHTML='<div class="cart-empty">Your cart is empty.<br>Discover Collection Eleven.</div>';
  }else{
    wrap.innerHTML=cart.items.map(i=>`<div class="ci">
      <div class="thumb">${i.image?`<img src="${i.image}" alt="">`:''}</div>
      <div class="info"><h4>${i.product_title}</h4>
      <div class="sz">${i.variant_title?i.variant_title:''}</div>
      <div class="qty"><button onclick="changeQty('${i.key}',${i.quantity-1})">−</button>
      <span>${i.quantity}</span>
      <button onclick="changeQty('${i.key}',${i.quantity+1})">+</button></div></div>
      <div><div class="price">${money(i.final_line_price)}</div>
      <button class="rm" onclick="changeQty('${i.key}',0)">Remove</button></div>
    </div>`).join('');
  }
  const sub=document.getElementById('subtotal'),tot=document.getElementById('total');
  if(sub)sub.textContent=money(cart.total_price);
  if(tot)tot.textContent=money(cart.total_price);
}
function openCart(){const c=document.getElementById('cart'),o=document.getElementById('overlay');if(c)c.classList.add('open');if(o)o.classList.add('open');}
function closeCart(){const c=document.getElementById('cart'),o=document.getElementById('overlay');if(c)c.classList.remove('open');if(o)o.classList.remove('open');}
function goCheckout(){window.location.href='/checkout';}
document.addEventListener('DOMContentLoaded',refreshCart);

/* ---- INQUIRY DRAWER ---- */
function openInquiry(productTitle,productUrl,variantTitle){
  const drawer=document.getElementById('inquiryDrawer');
  const overlay=document.getElementById('inquiryOverlay');
  if(!drawer||!overlay)return;
  const product=document.getElementById('InquiryProduct');
  const variant=document.getElementById('InquiryVariant');
  const url=document.getElementById('InquiryUrl');
  const message=document.getElementById('InquiryMessage');
  if(product)product.value=productTitle||'';
  if(variant)variant.value=variantTitle||'';
  if(url)url.value=productUrl||window.location.href;
  if(message&&productTitle){
    const variantCopy=variantTitle&&variantTitle!=='Default Title'?` (${variantTitle})`:'';
    message.value=`I would like to inquire about ${productTitle}${variantCopy}.`;
  }
  drawer.classList.add('open');
  overlay.classList.add('open');
}
function openInquiryFromButton(btn){
  const selected=window.LOUBELLE_VARIANTS&&selectedVariantId?window.LOUBELLE_VARIANTS[selectedVariantId]:null;
  openInquiry(btn&&btn.dataset?btn.dataset.product:'',btn&&btn.dataset?btn.dataset.url:'',selected?selected.title:'');
}
function closeInquiry(){
  const drawer=document.getElementById('inquiryDrawer');
  const overlay=document.getElementById('inquiryOverlay');
  if(drawer)drawer.classList.remove('open');
  if(overlay)overlay.classList.remove('open');
}
document.addEventListener('DOMContentLoaded',()=>{
  if(window.location.search.includes('contact_posted=true'))openInquiry();
});

/* ---- NEWSLETTER POPUP ---- */
function openNewsletter(){const n=document.getElementById('npOverlay');if(n)n.classList.add('open');}
function closeNewsletter(){const n=document.getElementById('npOverlay');if(n)n.classList.remove('open');}
window.addEventListener('load',()=>{
  if(!document.getElementById('npOverlay'))return;
  if(!sessionStorage.getItem('np_seen')){
    setTimeout(()=>{openNewsletter();sessionStorage.setItem('np_seen','1')},6000);
  }
});
